import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Banner from '../BannerSection/Banner';
import Course from '../Course/Course';

const Home = () => {
    const [data, setData] = useState([]);
    useEffect(() => {
        fetch('./home.json')
            .then(res => res.json())
            .then(data => setData(data));

    }, []);
    return (
        <div>
            <div>
                <Banner></Banner>
            </div>
            <div>

            </div>
            <div>

                <Row xs={1} md={4} className="g-4 m-5 ">
                    {
                        data.map(data => <Course
                            key={data.id}
                            data={data}
                        >
                        </Course>)
                    }


                </Row>
            </div>
        </div>
    );
};

export default Home;